import types from '../actions/pages/types';

const initialState = {
  pagesList: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.GET_PAGES_LIST:
      return { ...state, pagesList: [] };
    case types.GET_PAGES_LIST_SUCCESS:
      return { ...state, pagesList: action.payload };
    default:
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/app/reducers/pages.js